import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ERROR_TOAST_MS = 8000;
const SUCCESS_TOAST_MS = 4500;
const DEFAULT_TOAST_MS = 5000;

export { ERROR_TOAST_MS };

function buildToastId(errorType, message, customId) {
  if (customId) return String(customId);
  const type = String(errorType ?? '').toLowerCase();
  const slug = String(message ?? '')
    .trim()
    .slice(0, 120)
    .replace(/\s+/g, '-')
    .toLowerCase();
  return `toast-${type}-${slug}`;
}

export function toastAlert(errorType, message, id, position = 'TOP_RIGHT') {
  const type = String(errorType ?? '').toLowerCase();
  const toastPosition =
    toast.POSITION[position] ?? toast.POSITION.TOP_RIGHT;
  const toastId = buildToastId(type, message, id);

  const autoClose =
    type === 'error'
      ? ERROR_TOAST_MS
      : type === 'success'
        ? SUCCESS_TOAST_MS
        : DEFAULT_TOAST_MS;

  const options = {
    autoClose,
    toastId,
    position: toastPosition,
    pauseOnHover: true,
    closeOnClick: true,
    hideProgressBar: false,
  };

  if (type === 'error') {
    toast.error(message, options);
  } else if (type === 'success') {
    toast.success(message, options);
  } else {
    toast.info(message, options);
  }
}
